const baseUrl = process.env.REACT_APP_BASE_URL + 'Analytics/adunits';

const AdunitApiService = {
  getAll: async () => {
    try {
      const response = await fetch(`${baseUrl}/all`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching adunits');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  getById: async (id) => {
    try {
      const response = await fetch(`${baseUrl}/${id}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Adunit not found');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  create: async (adunit) => {
    try {
      const response = await fetch(`${baseUrl}/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(adunit),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error creating adunit');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  update: async (adunit) => {
    try {
      const response = await fetch(`${baseUrl}/update`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(adunit),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error updating adunit');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  delete: async (id) => {
    try {
      const response = await fetch(`${baseUrl}/delete/${id}`, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error deleting adunit');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  getAdFile: async (id) => {
    try {
      const response = await fetch(`${baseUrl}/GetAdFile?fileId=${id}`, {
        method: 'GET',
        //headers: { 'Content-Type': 'application/json' },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error fetching adunits');
      }
      const blob = await response.blob(); // Convert response to Blob
      return await blob.text(); // Convert Blob to text
  
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },

  UpdateAdFile :  async (fileData) => {
    try {
      const response = await fetch(`${baseUrl}/UpdateAdFiles`, {
        method: 'POST',
        body: fileData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Error updating file');
      }

      return await response.json();
    } catch (error) {
      console.error('Error:', error);
      throw new Error('Network error');
    }
  },
};

export default AdunitApiService;
